module.exports = __webpack_public_path__ + "static/media/wallet.ec576bc7.png";